export default __webpack_public_path__ + "static/media/logo.d0b38286.png";